const getters = {
    tabList: state => state.tabs.tabList,
    user: state => state.user.user,
    menus: state => state.user.menus,
    btns: state => state.user.btns,
    theme: state => state.theme.theme,
}
export default getters